export const EnergyOfferParametersGeneration = (offerData, selectedProviderId, country) => {
  const options = new URLSearchParams()
  options.append('lang', country)
  const parametersToExclude = ['created_at', 'updated_at', 'organisation', 'is_complete', 'usable_for_netting_process']
  const countryToIncludeAttributes = ['it']

  for (const [name, value] of Object.entries(offerData)) {
    if (countryToIncludeAttributes.includes(country) && name.startsWith('attr_')) {
      options.append(name, value)
      continue
    }
    if (value !== undefined && value !== null && value.toString().length > 0 && !parametersToExclude.includes(name)) {
      options.append(name, value)
    }
  }

  if (!offerData.organisation_id) {
    options.append('organisation_id', selectedProviderId)
  }

  if (!offerData.id) {
    options.append('id', 0)
  }

  if (!offerData.debordement_call_status) {
    options.append('debordement_call_status', '0')
    options.append('debordement_call_zoho_id', '')
  }

  if (offerData.energy_type === 'elec' || offerData.energy_type === 'gas') {
    const zohoKey = offerData.energy_type === 'elec' ? 'elec_zoho_id' : 'gas_zoho_id'
    options.append(zohoKey, offerData.zoho_id ?? '')
  }

  if (offerData.energy_type === 'propane') {
    options.append('propane_zoho_id', offerData.zoho_id ?? '')
  }

  if (offerData.energy_type === 'dual') {
    options.append('gas_zoho_id', offerData.gas_zoho_id ?? '')
    options.append('elec_zoho_id', offerData.elec_zoho_id ?? '')
  }

  const usableNettingValue = !offerData.usable_for_netting_process ? 0 : 1

  options.append('usable_for_netting_process', usableNettingValue)

  return options
}
